<template>
  <v-dialog
    v-model="editContactDlgState"
    persistent
    max-width="600px"
  >
  <v-form v-model="valid">
    <v-card class="card-block">
      <v-card-title class="px-0">
        <span class="headline">Добавление контакта1</span>
      </v-card-title>
      <v-card-text class="px-0">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-subheader class="pa-0">ТЕЛЕФОН</v-subheader>

              <div class='lfs-pd-input-block'>
                <v-text-field
                  v-model="contact.phone"
                  color='#2c9cdb'
                  :counter='15'
                  placeholder="Введите номер телефона"
                  :rules="phoneRules"
                />

                <div class='lfs-pd-input-block-requred'></div>
              </div>
            </v-col>

            <v-col cols="12">
              <v-subheader class="pa-0">E-MAIL</v-subheader>

              <div class='lfs-pd-input-block'>
                <v-text-field
                  v-model="contact.email"
                  color='#2c9cdb'
                  :counter='50'
                  placeholder="Введите ваш e-mail"
                  :rules="emailRules"
                />

                <div class='lfs-pd-input-block-requred'></div>
              </div>
            </v-col>

            <v-col cols="12">
              <v-subheader class="pa-0">САЙТ</v-subheader>

              <div class='lfs-pd-input-block'>
                <v-text-field
                  v-model="contact.site"
                  color='#2c9cdb'
                  :counter='2048'
                  placeholder="Введите имя вашего сайта"
                  :rules="siteRules"
                />

                <div class='lfs-pd-input-block-requred'></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="justify-space-between pa-0 mx-0 mt-5">
        <v-btn
          class="white--text btn"
          color="#2D9CDB"
          @click="onSubmit"
          :disabled="!valid"
        >
          {{$t('profile.header.button_edit')}}
        </v-btn>

        <v-btn
          class="white--text btn"
          color="#EB5757"
          @click="onClose"
        >
          {{$t('profile.header.button_exit')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ['editContactDlgState', 'company'],

  data: () => ({
    valid: true,

    contact: {
      phone: '',
      email: '',
      site: ''
    },

    phoneRules: [
      v => !!v || 'Поле обязательно для заполнения',
      v => (v && v.length <= 15) || 'Введите не более 15 символов',
    ],

    emailRules: [
      v => !!v || 'Поле обязательно для заполнения',
      v => /.+@.+\..+/.test(v) || 'Введите корректные тип e-mail',
      v => (v && v.length <= 50) || 'Введите не более 50 символов',
    ],

    siteRules: [
      v => !!v || 'Поле обязательно для заполнения',
      v => (v && v.length <= 2048) || 'Введенное значение слишком длинное',
    ],
  }),

  methods: {
    onSubmit() {
      let contacts = this.company.contacts.map(item => {
        item.value = this.contact[item.type]

        return item
      })

      this.$store.dispatch('profile/editCompanyContacts', contacts)

      this.$emit('closeModal')
    },

    onClose() {
      this.$emit('closeModal')

      this.company.contacts.forEach(element => {
        this.contact[element.type] = element.value
      });
    }
  },

 mounted() {
    this.company.contacts.forEach(element => {
      this.contact[element.type] = element.value
    });
  }
}
</script>

<style lang="scss" scoped>
  .card-block {
    padding: 30px;
  }

  .btn {
    width: 210px;
  }
</style>

